import { render, staticRenderFns } from "./ViewSignatureDialog.vue?vue&type=template&id=c3568bf4&scoped=true"
import script from "./ViewSignatureDialog.vue?vue&type=script&lang=js"
export * from "./ViewSignatureDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewSignatureDialog.vue?vue&type=style&index=0&id=c3568bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3568bf4",
  null
  
)

export default component.exports